window.addEventListener("DOMContentLoaded",function(){


$('.gifting_module .radio').click(function() {
  $('.gifting_module .radio').removeClass('selected');
  $(this).addClass('selected');
  if($(this).hasClass('yes')) {
    $('.gift_options').show();
  } else {
    $('.gift_options').hide();
  }
});


$('.gift_options img').click(function(){
  var self = $(this).parent();
  var curitem = $(self).attr('id');
  $(self).toggleClass('selected');
  // alert(curitem);
  atcFunc(curitem);
});


function atcFunc(curitem) {
  if($('#'+curitem).hasClass("selected")) {
    var prodcount = parseInt($('#'+curitem).attr("data-id"));
    $('#'+curitem).attr("data-id", prodcount+1)
    //alert(prodcount+1);
    $.ajax({
        type: "POST",
        url: '/cart/add',
        data: 'quantity=1&id='+curitem,
        dataType: "json",
        success: function(data) {
          console.log('Product Added to Cart, new count is', prodcount);
          console.log(prodcount);
        },
        error: function() {
          console.log('error handling here');
        }
    });
  } else {
    var prodcount = parseInt($('#'+curitem).attr("data-id"));
    prodcount = prodcount-1;
    $('#'+curitem).attr("data-id", prodcount)
    //alert(prodcount);
    $.ajax({
        type: "POST",
        url: '/cart/change',
        data: 'quantity='+prodcount+'&id='+curitem,
        dataType: "json",
        success: function(data) {
          console.log('Product removed from Cart, new count is', prodcount);
          console.log(prodcount);
        },
        error: function() {
          console.log('error handling here');
        }
    });
  }
};
  
});